import Error from './error';

export default Error;
export { Error };
